'use strict';

var path = require('path');

var imageExtensions = require('image-extensions');

var extensions = new Set(imageExtensions);

module.exports = function (filePath) {
  return extensions.has(path.extname(filePath).slice(1).toLowerCase());
};